import { DataSymbol } from '~/api-services/LoadService/types';
import { SelectOption } from '~/components/core/SearchableSelect';

// Every streamed symbol, shown as the short ticker (label) over the long descriptive name
// (sublabel) — the raw code takes the second row only when the symbol carries no distinct
// description. Sorted by the short name, which is what both pickers display. Shared by the
// create wizard's market picker and the list's instrument filter so the two cannot drift.
// Callers memoize on `symbolsMap`: it changes identity on every quote tick.
export const buildInstrumentOptions = (symbolsMap: { [code: string]: DataSymbol }): SelectOption[] =>
    Object.keys(symbolsMap)
        .sort((a, b) => (symbolsMap[a]?.nameTranslated ?? a).localeCompare(symbolsMap[b]?.nameTranslated ?? b))
        .map((code) => {
            const symbol = symbolsMap[code];
            const short = symbol?.nameTranslated || code;
            const long = symbol?.descriptionTranslated;
            return {
                value: code,
                label: short,
                sublabel: long && long !== short ? long : symbol?.nameTranslated ? code : undefined,
            };
        });
